import { Check, X } from "lucide-react";

const ACCENT = "#BEF264";

const ROWS = [
  ["Displays business information", "Connects content to customer actions"],
  ["Sends basic form notifications", "Records enquiries in a configured CRM"],
  ["Often relies on manual follow-up", "Supports automated follow-up"],
  ["Has limited visibility into sales", "Tracks opportunities through a pipeline"],
  ["Reports traffic", "Connects available traffic and lead information"],
  ["Stops at the enquiry", "Supports the next stages of the sales journey"],
];

export default function SalesComparison() {
  return (
    <section id="comparison" aria-labelledby="comparison-heading" data-testid="sales-comparison-section" className="relative py-20 sm:py-28 bg-sales-navy text-white">
      <div className="mx-auto max-w-5xl px-5 sm:px-8">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 id="comparison-heading" className="font-display text-4xl sm:text-5xl font-black tracking-[-0.03em] leading-[1.04]">
            A Standard Business Website vs a <span style={{ color: ACCENT }}>Connected Sales System</span>
          </h2>
          <p className="mt-4 text-white/55 text-sm sm:text-base">
            A lead generation website compared with a conventional basic website — and what Rekisa's connected implementation adds.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-4">
          {/* Standard website */}
          <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-5">
            <div className="text-[11px] font-bold uppercase tracking-wider text-white/40 mb-4">Conventional basic website</div>
            <div className="space-y-3">
              {ROWS.map(([std]) => (
                <div key={std} className="flex items-start gap-3">
                  <span className="mt-0.5 h-5 w-5 rounded-full bg-white/[0.06] text-white/40 flex items-center justify-center shrink-0">
                    <X className="h-3 w-3" />
                  </span>
                  <span className="text-sm text-white/50 leading-snug">{std}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Rekisa */}
          <div className="rounded-2xl border p-5" style={{ borderColor: `${ACCENT}55`, background: `${ACCENT}0d` }}>
            <div className="text-[11px] font-bold uppercase tracking-wider mb-4" style={{ color: ACCENT }}>Rekisa Sales System</div>
            <div className="space-y-3">
              {ROWS.map(([, rk]) => (
                <div key={rk} className="flex items-start gap-3">
                  <span className="mt-0.5 h-5 w-5 rounded-full flex items-center justify-center shrink-0" style={{ background: ACCENT }}>
                    <Check className="h-3 w-3 text-[#0B1120]" />
                  </span>
                  <span className="text-sm text-white/85 font-medium leading-snug">{rk}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
